import React from "react";

export default function Error500Page() {
  return <div>Error500Page</div>;
}
